// Motion Director jobs started from Sync with AI: EditorApp places their result itself the moment
// the job completes (and then tells the tray, aidea:jobApplied). The tray uses the mark to leave
// their completion toast to the editor. ponytail: in-memory — after a reload the tray toasts and
// the card waits for Approve like any other.
const ids = new Set();

export const markMotionAutoApply = (jobId) => void ids.add(jobId);

export const isMotionAutoApply = (jobId) => ids.has(jobId);
